export const NavBarModeEnum = {
  'Light': 'LIGHT',
  'Dark': 'DARK',
};
